import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

const fb = require('./../firebase/firebase')

Vue.use(Vuex)

// handles page reload
fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('SET_CURRENT_USER', user)
    store.dispatch('fetchUserProfile')

    fb.usersCollection.doc(user.uid).onSnapshot(doc => {
      store.commit('SET_USER_PROFILE', doc.data())
    })
  } else {
    // store.commit('SET_CURRENT_USER', null)
    store.dispatch('clearData')
  }
})

// commit mutations, dispatch actions

export const store = new Vuex.Store({
  state: {
    currentUser: null,
    userProfile: null,
    districtId: null,
    adminWhichComponent: 'districtList',
    userToManage: null,
    generalMsg: null,
    dashboardView: 'units',
    // trainingToRegister: null,
    trainingsToRegister: [],
    registrationToEdit: null,
    regHelper: null,
    msg: false
  },
  mutations: {
    SET_CURRENT_USER(state, val){
      state.currentUser = val
    },
    SET_USER_PROFILE(state, val) {
      state.userProfile = val
    },
    SET_DISTRICT_ID(state, val) {
      state.districtId = val
    },
    SET_ADMIN_WHICH_COMPONENT(state, val) {
      state.adminWhichComponent = val
    },
    SET_GENERAL_MSG(state, val) {
      state.generalMsg = val
    },
    SET_DASHBOARD_VIEW(state, val) {
      state.dashboardView = val
    },
    SET_USER_TO_MANAGE(state, val) {
      state.userToManage = val
    },
    // SET_TRAINING_TO_REGISTER(state, val) {
    //   state.trainingToRegister = val
    // },
    SET_TRAININGS_TO_REGISTER(state, val) {
      state.trainingsToRegister = val
    },
    SET_REGISTRATION_TO_EDIT(state, val) {
      state.registrationToEdit = val
    },
    SET_REG_HELPER(state, val) {
      state.regHelper = val
    },
    SET_MSG(state, val) {
      state.msg = val
    }
  },
  actions: {
    clearData({ commit }) {
      commit('SET_CURRENT_USER', null)
      commit('SET_USER_PROFILE', null)
      commit('SET_DISTRICT_ID', null)
      commit('SET_ADMIN_WHICH_COMPONENT', 'districtList')
      commit('SET_GENERAL_MSG', null)
      commit('SET_DASHBOARD_VIEW', 'units')
      commit('SET_USER_TO_MANAGE', null)
      // commit('SET_TRAINING_TO_REGISTER', null)
      commit('SET_TRAININGS_TO_REGISTER', [])
      commit('SET_REGISTRATION_TO_EDIT', null)
      commit('SET_REG_HELPER', [])
      commit('SET_MSG', false)
    },
    // fetchUserProfile({ commit, state }) {
    //   fb.usersCollection.where('userId', '==', state.currentUser.uid).get().then(res => {
    //     commit('SET_USER_PROFILE', res.data())
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // }
    fetchUserProfile({ commit, state }) {
      fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
        commit('SET_USER_PROFILE', res.data())
      }).catch(err => {
        console.log(err)
      })
    }
  },
  plugins: [createPersistedState()]
})


// export default new Vuex.Store({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
